module.exports = __webpack_public_path__ + "img/fam-profile.b331e154.png";